import Index from '@/pages/triggers/Index'
import Form from '@/pages/triggers/Form'

const TriggersRoutes = [
    { name: 'trigger.index', path: '/trigger', component: Index, meta: {perfil: 'root'}},
    { name: 'trigger.create', path: '/trigger/create', component: Form, meta: {perfil: 'root'}},
    {name: 'trigger.edit',  path: '/trigger/edit/:id', component: Form, meta: {perfil: 'root'}}
];

export default TriggersRoutes;
